import { render, staticRenderFns } from "./WxMsgManage.vue?vue&type=template&id=55d0e9ca&scoped=true&lang=pug&"
import script from "./WxMsgManage.vue?vue&type=script&lang=ts&"
export * from "./WxMsgManage.vue?vue&type=script&lang=ts&"
import style0 from "./WxMsgManage.vue?vue&type=style&index=0&id=55d0e9ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d0e9ca",
  null
  
)

export default component.exports